import { useRef, useState } from 'react'
import { IAutoCompleteAddress } from '../models/address_auto_complete'
import { useDebouncedCallback } from './use_debounced_callback'
import { addressCheck } from '../api/mutations'
import REGEX from '../constants/regex'
import { useAppSelector } from './state'
import { getResourceAuthorization } from '../state/selectors/resource_authorization'

export function useAutocompleteAddress () {
  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)
  const [isLoading, setIsLoading] = useState(false)
  const lastValidatedAddressRef = useRef<{
    zipCode?: string,
    houseNumber?: number,
    address?: IAutoCompleteAddress
  }>({})

  const validateAddressWithDebounce = useDebouncedCallback((zipCode, houseNumber, callback, errorCallback) => {
    const refKey = currentResourceAuthorization?.relationInfo?.agentNumber
    const relationNumber = currentResourceAuthorization?.relationInfo?.relationNumber

    const zipCodeTrimmed = zipCode.trim()
    const zipCodeFormatted = zipCodeTrimmed.replace(/\s/g, '')

    if (!refKey || !relationNumber || !zipCodeTrimmed || !houseNumber) {
      return
    }

    if ((!zipCodeFormatted.match(REGEX.zipCode) && zipCodeFormatted.length < 6) || houseNumber <= 0) {
      return
    }

    const last = lastValidatedAddressRef.current

    if (
      last.zipCode === zipCodeFormatted &&
        last.houseNumber === houseNumber &&
        last.address
    ) {
      callback(last.address)

      return
    }

    setIsLoading(true)

    const houseNumberStr = String(houseNumber)

    addressCheck(refKey, relationNumber, zipCodeTrimmed, houseNumberStr).then((res) => {
      lastValidatedAddressRef.current = {
        zipCode: zipCodeFormatted,
        houseNumber,
        address: res.data
      }

      callback(res.data)
    }).catch(() => {
      errorCallback?.()
    }).finally(() => {
      setIsLoading(false)
    })
  }, 1000)

  return {
    validateAddressWithDebounce,
    isLoading
  }
}

